'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'parachute-box';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f4cd';
var svgPathData = ['M32.6 192l96.9 0c4.7-76.1 26.2-141.8 56.7-182-83.1 25.5-146.6 95.1-153.6 182zm128.9 0l189.9 0C347.9 138.5 335.5 91.6 318.4 57.3 296.9 14.4 273.2 0 256.5 0s-40.4 14.4-61.9 57.3c-17.2 34.3-29.5 81.2-33.1 134.7zm30.9 192l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zM326.8 10c30.6 40.2 52 105.9 56.7 182l96.9 0c-7-86.9-70.5-156.5-153.6-182z', 'M383.5 192c-4.7-76.1-26.2-141.8-56.7-182 83.1 25.5 146.6 95.1 153.6 182l-96.9 0zm-32.1 0l-189.9 0C165.1 138.5 177.4 91.6 194.6 57.3 216.1 14.4 239.8 0 256.5 0s40.4 14.4 61.9 57.3c17.2 34.3 29.5 81.2 33.1 134.7zm-222 0l-96.9 0c7-86.9 70.5-156.5 153.6-182-30.6 40.2-52 105.9-56.7 182zm-69 32l180 0 0 96-16 0c-12.7 0-24.5 3.7-34.4 10L60.5 224zm212 0l180 0-129.6 106c-9.9-6.3-21.7-10-34.4-10l-16 0 0-96zM6.7 220l162 132.6c-5.2 9.3-8.2 20-8.2 31.4l0 64c0 35.3 28.7 64 64 64l64 0c35.3 0 64-28.7 64-64l0-64c0-11.4-3-22.2-8.2-31.4L506.3 220c3.6-2.9 5.7-7.3 5.7-12 0-134.7-114.8-234.7-246.1-239.3-3.1-.5-6.2-.7-9.4-.7s-6.3 .2-9.4 .7C115.8-26.7 1 73.3 1 208 1 212.6 3.1 217 6.7 220zM224.5 352l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faParachuteBox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;